export type Language = 'en' | 'de' | 'ar';

export const translations = {
  ar: {
    nav: {
      platforms: "المنصات",
      process: "العملية",
      startAnalysis: "اختبار مجاني !"
    },
    hero: {
      title: "جاهز\nللشهرة؟",
      subtitle: "نعم، نحن الذين نزيد وصولك بأقل من 10 يورو وأكثر من ذلك بكثير",
      startAnalysis: "اختبار مجاني !",
      info: "معلومات",
      tellMeMore: "لماذا تحتاج إلى MediaMagnet في 2026"
    },
    platforms: {
      title: "نمو غير محدود",
      subtitle: "نقوم بتحسين تواجدك حيث يتواجد عملاؤك.",
      learnMore: "تعلم المزيد",
      items: {
        instagram: {
          title: "Instagram Growth",
          description: "نزيد من وصولك من خلال استراتيجيات Reels وإدارة المجتمع المستهدفة."
        },
        facebook: {
          title: "Facebook Performance",
          description: "الحملات الإعلانية القائمة على البيانات واستراتيجيات المحتوى لنتائج B2B ملموسة."
        },
        google: {
          title: "Google Maps Visibility",
          description: "سيطر على البحث المحلي واكسب العملاء مباشرة في منطقتك."
        },
        tiktok: {
          title: "TikTok Virality",
          description: "استفد من الخوارزمية لتحقيق أقصى قدر من الوصول العضوي والاتجاهات الفيروسية."
        },
        youtube: {
          title: "YouTube Authority",
          description: "ثبت نفسك كقائد في السوق من خلال محتوى فيديو عالي الجودة وتحسين محركات البحث."
        },
        telegram: {
          title: "Telegram Growth",
          description: "قم بتنمية قناتك أو مجموعتك على Telegram من خلال أعضاء حقيقيين ومستهدفين."
        }
      }
    },
    process: {
      title: "النجاح في 4 خطوات",
      steps: [
        "اختر المنصة",
        "اختر خدمتك",
        "أرسل رابط الحساب",
        "استلم الطلب"
      ]
    },
    tracking: {
      title: "تتبع الطلب",
      subtitle: "أدخل رقم طلبك للتحقق من الحالة",
      placeholder: "أدخل رقم الطلب",
      button: "تحقق من الطلب",
      validProcessing: "تم استلام طلبك. تستغرق المعالجة حوالي 4-5 ساعات.\n\nتستغرق المعالجة عادةً من 3 إلى 4 ساعات بسبب اختلاف المناطق الزمنية. الحد الأقصى لوقت المعالجة هو 24 ساعة.\n\nإذا اقترب طلبك من علامة الـ 24 ساعة، يرجى ملاحظة أن هذا قد يكون بسبب معلومات غير صالحة أو روابط غير صالحة تم تقديمها.\n\nمع اقتراب وقت المعالجة من 24 ساعة، ستكون النتيجة الأكثر احتمالاً هي استرداد الأموال إلى حساب PayPal الخاص بك.",
      completed: "✔ طلبك جاهز وتم شحنه!",
      invalid: "رقم الطلب غير موجود. يرجى التحقق من إدخالك.."
    },
    footer: {
      rights: "© 2026 MediaMagnet Digital Agency. All rights reserved.",
      imprint: "بصمة",
      privacy: "الخصوصية",
      terms: "الشروط"
    },
    modals: {
      info: {
        loading: "جاري تحميل الإنفوجرافيك...",
        error: "تعذر تحميل الصورة.",
        retry: "حاول مرة أخرى"
      },
      funnel: {
        step1: "ما هي المنصة التي ترغب في تحسينها؟",
        step2: "أرخص الأسعار في 🌍",
        step3: "من يجب أن يربح؟",
        labels: {
          company: "اسم الشركة",
          email: "البريد الإلكتروني",
          url: "رابط فيديو",
          commenterUsername: "اسم مستخدم صاحب التعليق"
        },
        placeholders: {
          company: "مثال المحدودة",
          email: "name@company.com",
          url: "",
          commenterUsername: "@اسم_المستخدم"
        },
        buttons: {
          back: "رجوع",
          request: "طلب تحليل",
          close: "إغلاق",
          buy: "احصل",
          next: "التالي",
          soldOut: "مباع بالكامل",
          comingSoon: "قريباً",
          beCreative: "كن مبدعاً...",
          upTo: "حتى",
          customise: "خصص الآن",
          commentsSuffix: "تعليقات",
          pay: "ادفع بواسطة PayPal أو البطاقة",
          customStep: {
            statement: "يرجى ملء الـ 10 تعليقات",
            question: "ماذا يجب أن تحتوي التعليقات؟",
            placeholder: "",
            videoQuestion: "أضف رابط الفيديو",
            urlHelp: "انقر هنا لمعرفة كيفية العثور على الرابط",
            commentLikesQuestion: "ما هو التعليق الذي يجب إرسال الإعجابات إليه؟",
            reactionQuestion: "أي تفاعل يجب استخدامه؟"
          }
        },
        payment: {
          title: "الدفع",
          subtitle: "اختر وسيلة الدفع المفضلة لديك",
          paypalCard: "PayPal أو بطاقة ائتمان"
        },
        success: {
          thanks: "شكراً!",
          message: "لقد استلمنا بياناتك وسنعاود الاتصال بك قريباً مع تحليلك المجاني."
        },
        platformGoals: {
          "Instagram": ["زيادة النمو", "تعزيز التفاعل", "دفع المنشورات"],
          "Facebook": ["زيادة الوصول", "تحسين الإعلانات"],
          "Google Maps": ["زيادة المراجعات", "تحسين الترتيب"],
          "TikTok": ["الانتشار الفيروسي", "بناء الجمهور", "استغلال الاتجاهات"],
          "YouTube": ["كسب المشتركين", "زيادة وقت المشاهدة", "تحسين محركات البحث"],
          "Telegram": ["زيادة الأعضاء", "تعزيز مشاهدات القناة", "دفع المنشورات"]
        }
      }
    }
  },
  en: {
    nav: {
      platforms: "Platforms",
      process: "Process",
      startAnalysis: "Free Test !"
    },
    hero: {
      title: "Ready for\nFame?",
      subtitle: "Yes, we're the ones boosting social media accounts with thousands of followers for under 10 euros and much more !",
      startAnalysis: "Free Test !",
      info: "Info",
      tellMeMore: "Why you need MediaMagnet in 2026"
    },
    platforms: {
      title: "Limitless Growth",
      subtitle: "We optimize your presence where your customers are.",
      learnMore: "Learn more",
      items: {
        instagram: {
          title: "Instagram Growth",
          description: "We increase your reach through Reels strategies and targeted community management."
        },
        facebook: {
          title: "Facebook Performance",
          description: "Data-driven advertising campaigns and content strategies for measurable B2B results."
        },
        google: {
          title: "Google Maps Visibility",
          description: "Dominate local search and win customers directly in your area."
        },
        tiktok: {
          title: "TikTok Virality",
          description: "Leverage the algorithm for maximum organic reach and viral trends."
        },
        youtube: {
          title: "YouTube Authority",
          description: "Establish yourself as a market leader through high-quality video content and SEO."
        },
        telegram: {
          title: "Telegram Growth",
          description: "Grow your Telegram channel or group with real, targeted members."
        }
      }
    },
    process: {
      title: "Success in 4 Steps",
      steps: [
        "Choose Platform",
        "Choose your service",
        "Send account link",
        "Receive Order"
      ]
    },
    tracking: {
      title: "Track order",
      subtitle: "Enter your order number to check the status",
      placeholder: "Enter order number",
      button: "Check order",
      validProcessing: "Your order is currently being processed\n\nProcessing usually takes 3–4 hours due to different time zones. The maximum processing time is 24 hours.\n\nIf your order is close to reaching the 24-hour mark, please note that this may be due to invalid information or invalid links being provided.\n\nAs the processing time nears 24 hours, the most probable outcome would be a refund to your PayPal account.",
      completed: "✔ Your order is ready and has been shipped!",
      invalid: "Order number not found. Please check your input.."
    },
    footer: {
      rights: "© 2026 MediaMagnet Digital Agency. All rights reserved.",
      imprint: "Imprint",
      privacy: "Privacy",
      terms: "Terms"
    },
    modals: {
      info: {
        loading: "Loading infographic...",
        error: "Image could not be loaded.",
        retry: "Try again"
      },
      funnel: {
        step1: "Which platform would you like to improve?",
        step2: "Cheapest prices in the 🌍",
        step3: "Who should gain?",
        labels: {
          company: "Company Name",
          email: "Email",
          url: "Video Link",
          addVideoLink: "how to find video link",
          commenterUsername: "Username of the commenter"
        },
        placeholders: {
          company: "Example Ltd",
          email: "name@company.com",
          url: "",
          commenterUsername: "@username"
        },
        buttons: {
          back: "Back",
          request: "Request Analysis",
          close: "Close",
          buy: "Get",
          next: "Next",
          soldOut: "sold out",
          comingSoon: "coming soon",
          beCreative: "Be creative...",
          upTo: "up to",
          customise: "customise now",
          commentsSuffix: "Comments",
          pay: "Pay with PayPal or Card",
          customStep: {
            statement: "Please fill out the 10 comments",
            question: "What should the comments contain?",
            placeholder: "",
            videoQuestion: "Add video link",
            urlHelp: "Click here to see how to find URL",
            commentLikesQuestion: "To which comment should the likes be sent?",
            reactionQuestion: "Which reaction should be used?"
          }
        },
        payment: {
          title: "Payment",
          subtitle: "Choose your preferred payment method",
          paypalCard: "PayPal or Credit Card"
        },
        success: {
          thanks: "Thanks!",
          message: "We have successfully received your order. Please screenshot your tracking code, as it will only be displayed once."
        },
        platformGoals: {
          "Instagram": ["Increase Growth", "Boost Engagement", "Push Posts"],
          "Facebook": ["Increase Reach", "Improve Ads"],
          "Google Maps": ["Increase Reviews", "Improve Ranking"],
          "TikTok": ["Go Viral", "Build Audience", "Leverage Trends"],
          "YouTube": ["Gain Subscribers", "Increase Watchtime", "Optimize SEO"],
          "Telegram": ["Increase Members", "Boost Channel Views", "Push Posts"]
        }
      }
    }
  },
  de: {
    nav: {
      platforms: "Plattformen",
      process: "Prozess",
      startAnalysis: "Kostenloser Test !"
    },
    hero: {
      title: "Bereit für\nBerühmtheit?",
      subtitle: "Ja, wir sind diejenigen, die Tausende Follower für Firmen und Influencer für unter 10 Euro liefern, und vieles mehr!",
      startAnalysis: "Kostenloser Test !",
      info: "Info",
      tellMeMore: "Warum Sie MediaMagnet in 2026 brauchen"
    },
    platforms: {
      title: "Grenzenlose Zahlensteigerung",
      subtitle: "Wir optimieren Ihre Präsenz dort, wo Ihre Kunden sind.",
      learnMore: "Mehr erfahren",
      items: {
        instagram: {
          title: "Instagram Wachstum",
          description: "Wir steigern Ihre Reichweite durch Reels-Strategien und gezieltes Community-Management."
        },
        facebook: {
          title: "Facebook Performance",
          description: "Datenbasierte Werbekampagnen und Content-Strategien für messbare B2B-Ergebnisse."
        },
        google: {
          title: "Google Maps Sichtbarkeit",
          description: "Dominieren Sie die lokale Suche und gewinnen Sie Kunden direkt in Ihrer Umgebung."
        },
        tiktok: {
          title: "TikTok Viralität",
          description: "Nutzen Sie den Algorithmus für maximale organische Reichweite und virale Trends."
        },
        youtube: {
          title: "YouTube Authority",
          description: "Etablieren Sie sich als Marktführer durch hochwertigen Video-Content und SEO."
        },
        telegram: {
          title: "Telegram Wachstum",
          description: "Lassen Sie Ihren Telegram-Kanal oder Ihre Gruppe mit echten, gezielten Mitgliedern wachsen."
        }
      }
    },
    process: {
      title: "In 4 Schritten zum Erfolg",
      steps: [
        "Plattform wählen",
        "Service wählen",
        "Konto Link schicken",
        "Bestellung erhalten"
      ]
    },
    tracking: {
      title: "Bestellung verfolgen",
      subtitle: "Geben Sie Ihre Bestellnummer ein, um den Status zu prüfen",
      placeholder: "Bestellnummer eingeben",
      button: "Bestellung prüfen",
      validProcessing: "Ihre Bestellung ist gerade in bearbeitung\n\nDie Bearbeitung dauert aufgrund unterschiedlicher Zeitzonen in der Regel 3–4 Stunden. Die maximale Bearbeitungszeit beträgt 24 Stunden.\n\nWenn Ihre Bestellung kurz vor der 24-Stunden-Marke steht, beachten Sie bitte, dass dies an ungültigen Informationen oder ungültigen Links liegen kann.\n\nDa sich die Bearbeitungszeit 24 Stunden nähert, ist das wahrscheinlichste Ergebnis eine Rückerstattung auf Ihr PayPal-Konto.",
      completed: "✔ Deine Bestellung ist fertig und wurde versandt!",
      invalid: "Bestellnummer nicht gefunden. Bitte überprüfen Sie Ihre Eingabe.."
    },
    footer: {
      rights: "© 2026 MediaMagnet Digital Agency. All rights reserved.",
      imprint: "Impressum",
      privacy: "Datenschutz",
      terms: "AGB"
    },
    modals: {
      info: {
        loading: "Lade Infografik...",
        error: "Bild konnte nicht geladen werden.",
        retry: "Erneut versuchen"
      },
      funnel: {
        step1: "Welche Plattform möchten Sie verbessern?",
        step2: "Die günstigsten Preise 🌍weit",
        step3: "Wer soll profitieren?",
        labels: {
          company: "Unternehmensname",
          email: "E-Mail",
          url: "Video Link",
          addVideoLink: "wie man das video link findet",
          commenterUsername: "Benutzername des Kommentators"
        },
        placeholders: {
          company: "Beispiel GmbH",
          email: "name@firma.de",
          url: "",
          commenterUsername: "@benutzername"
        },
        buttons: {
          back: "Zurück",
          request: "Analyse anfordern",
          close: "Schließen",
          buy: "Holen",
          next: "Weiter",
          soldOut: "ausverkauft",
          comingSoon: "demnächst",
          beCreative: "Sei kreativ...",
          upTo: "bis zu",
          customise: "jetzt anpassen",
          commentsSuffix: "Kommentare",
          pay: "Mit PayPal oder Karte bezahlen",
          customStep: {
            statement: "Bitte füllen Sie die 10 Kommentare aus",
            question: "Was sollen die Kommentare enthalten?",
            placeholder: "",
            videoQuestion: "Video-Link hinzufügen",
            urlHelp: "Hier klicken, um zu sehen, wie man die URL findet",
            commentLikesQuestion: "An welchen Kommentar sollen die Likes gesendet werden?",
            reactionQuestion: "Welche Reaktion soll verwendet werden?"
          }
        },
        payment: {
          title: "Zahlung",
          subtitle: "Wählen Sie Ihre bevorzugte Zahlungsmethode",
          paypalCard: "PayPal oder Kreditkarte"
        },
        success: {
          thanks: "Danke!",
          message: "Wir haben Ihre Bestellung erfolgreich erhalten. Bitte machen Sie einen Screenshot von Ihrem Verfolgungscode, da er nur einmalig angezeigt wird."
        },
        platformGoals: {
          "Instagram": ["Wachstum steigern", "Engagement steigern", "Beiträge pushen"],
          "Facebook": ["Reichweite erhöhen", "Ads verbessern"],
          "Google Maps": ["Bewertungen erhöhen", "Ranking verbessern"],
          "TikTok": ["Viral gehen", "Publikum aufbauen", "Trends nutzen"],
          "YouTube": ["Abonnenten gewinnen", "Watchtime erhöhen", "SEO optimieren"],
          "Telegram": ["Mitglieder erhöhen", "Kanal-Aufrufe steigern", "Beiträge pushen"]
        }
      }
    }
  }
};
